import { Container } from '@chakra-ui/react'
import { FC, useEffect, useState } from 'react'
import { decodeToken } from 'react-jwt'
import { useImmer } from 'use-immer'

import useAuth from '@hook/shared/use-auth'
import useFilters from '@hook/shared/use-filters'
import useHome from '@hook/shared/use-home'
import { TokenProps } from '@provider/Shared/UserAuthProvider'

import Layout from '@component/Layout'
import OverviewCards from '@component/Pages/Overview/Cards'
import OverviewCarousel from '@component/Pages/Overview/Carousel'
import Filter from '@component/Shared/Filter'

import { validateAppVersion } from '@helper/util/storangeClear'
import generic from '@service/generic'

const Overview: FC = () => {
  const { companies } = useFilters()
  const [isUser, setIsUser] = useState(false)
  const { companies: authCompanies } = useAuth()

  const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID
  const audience = process.env.REACT_APP_AUTH0_AUDIENCE

  const {
    updateDataVenda,
    updateDataAlerta,
    updateDataFollowUp,
    updateDataFollowUpReab,
    updateDataEncomenda,
    updateDataSlsf,
    updateDataSemVendas,
    updateDataEstoqueExcesso,
    updateDataCarteiraFornecedor,
    updateDataRupture,
    updateDataActualSales,
    updateDataPurchaseOrders
  } = useHome()

  const [form, updateForm] = useImmer({
    empresas: []
  })

  const { getFilters } = useFilters()

  useEffect(() => {
    const userInfos = JSON.parse(
      localStorage.getItem(
        `@@auth0spajs@@::${clientId}::${audience}::openid profile email offline_access`
      )
    )
    const decodedToken = decodeToken(userInfos?.body.access_token) as TokenProps
    setIsUser(!!decodedToken?.role)
    decodedToken?.role &&
      generic
        .getMaintence('manutencao')
        .then(({ data: { data } }) => {
          validateAppVersion(data.version)

          if (data.valor === 'true') {
            if (data?.tipoStatusManutencao === 0) {
              window.location.href = '/manutencao'
            } else {
              window.location.href = '/job'
            }
          } else {
            getFilters({
              companies: true
            })
          }
        })
        .catch(() => {})

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Layout title="Visão Geral" withBackdroundDrop>
      <Container maxW="container.lg">
        {authCompanies?.length > 1 && (
          <Filter
            label="Empresas"
            whiteLabel
            marginTop={3}
            options={companies}
            value={
              JSON.parse(localStorage.getItem('@companies:'))
                ? JSON.parse(localStorage.getItem('@companies:')).map(
                    (empresa: any) =>
                      companies.find(company => company.value === empresa)!
                  )
                : form.empresas.map(
                    (empresa: any) =>
                      companies.find(company => company.value === empresa)!
                  )
            }
            onChange={values => {
              updateDataVenda([])
              updateDataFollowUp(null)
              updateDataFollowUpReab(null)
              updateDataAlerta({
                alertaCompras: null,
                alertaRecebimento: null
              })
              updateDataEncomenda([])
              updateDataSlsf([])
              updateDataSemVendas([])
              updateDataEstoqueExcesso([])
              updateDataCarteiraFornecedor([])
              updateDataRupture([])
              updateDataActualSales({
                vendaReal: null,
                vendaOrcada: null
              })
              updateDataPurchaseOrders([])

              updateForm((draft: any) => {
                draft.empresas = values!.map((option: any) => option.value)

                if (!localStorage.getItem('@companies:')) {
                  localStorage.setItem(
                    '@companies:',
                    JSON.stringify(draft.empresas)
                  )
                } else {
                  JSON.parse(localStorage.getItem('@companies:'))

                  localStorage.setItem(
                    '@companies:',
                    JSON.stringify(draft.empresas)
                  )
                }
              })
            }}
            isLoading={false}
            isMulti
          />
        )}
        {isUser && (
          <>
            <OverviewCards empresas={form.empresas} />
            <OverviewCarousel empresas={form.empresas} />
          </>
        )}
      </Container>
    </Layout>
  )
}

export default Overview
